// frontend/src/components/Navbar.js
import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { defaultAvatars } from '../services/avatars';
import api from '../services/api';
import NotificationBell from './NotificationBell';

const defaultAvatar = defaultAvatars.length > 0 ? defaultAvatars[0] : '';
const POLLING_INTERVAL = 10000;

function Navbar() {
  const [user, setUser] = useState(null);
  const [noLeidos, setNoLeidos] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    const updateUser = () => {
      const userData = sessionStorage.getItem('user');
      if (userData) {
        try { setUser(JSON.parse(userData)); }
        catch (e) { setUser(null); }
      } else {
        setUser(null);
      }
    };
    updateUser();
    window.addEventListener('storage', updateUser);
    return () => window.removeEventListener('storage', updateUser);
  }, []);

  useEffect(() => {
    const token = sessionStorage.getItem('token');
    if (!token || !user) { setNoLeidos(0); return; }

    const fetchNoLeidos = async () => {
      try {
        const res = await api.get('/mensajes/no-leidos');
        setNoLeidos(res.data.count);
      } catch (e) {}
    };

    fetchNoLeidos();
    const interval = setInterval(fetchNoLeidos, POLLING_INTERVAL);
    return () => clearInterval(interval);
  }, [user]);

  const handleLogout = () => {
    sessionStorage.removeItem('token');
    sessionStorage.removeItem('user');
    setNoLeidos(0);
    window.dispatchEvent(new Event('storage'));
    navigate('/');
  };

  const token = sessionStorage.getItem('token');

  return (
    <nav className="navbar navbar-expand-lg navbar-light bg-white shadow-sm">
      <div className="container">
        <Link className="navbar-brand d-flex align-items-center" to="/">
          <img src="/images/logo.png" alt="Mercado Jopoi" height="60" className="d-none d-md-block" />
          <img src="/images/logo-isotipo.png" alt="Mercado Jopoi" height="40" className="d-block d-md-none" />
        </Link>

        <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav">
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="navbar-nav ms-auto align-items-center">
            {token && user ? (
              <>
                <li className="nav-item me-2">
                  <Link className="btn btn-primary" to="/publicar">Publicar</Link>
                </li>

                {/* Campana de notificaciones push */}
                <li className="nav-item">
                  <NotificationBell />
                </li>

                {/* Icono de mensajes con badge */}
                <li className="nav-item me-2">
                  <Link className="nav-link position-relative p-2" to="/mensajes" title="Mensajes">
                    <i className="bi bi-chat-dots fs-5"></i>
                    {noLeidos > 0 && (
                      <span
                        className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger"
                        style={{ fontSize: '0.65rem' }}
                      >
                        {noLeidos > 9 ? '9+' : noLeidos}
                      </span>
                    )}
                  </Link>
                </li>

                {/* Dropdown de usuario */}
                <li className="nav-item dropdown">
                  <div
                    className="nav-link dropdown-toggle d-flex align-items-center"
                    style={{ cursor: 'pointer' }}
                    id="navbarDropdown"
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    {(user.avatar_url || defaultAvatar) && (
                      <img
                        src={user.avatar_url || defaultAvatar}
                        alt="avatar"
                        style={{ width: '32px', height: '32px', borderRadius: '50%', marginRight: '8px', objectFit: 'cover' }}
                      />
                    )}
                    {user.username}
                  </div>
                  <ul className="dropdown-menu dropdown-menu-end">
                    <li><Link className="dropdown-item" to="/mis-publicaciones">Mis Publicaciones</Link></li>
                    <li><Link className="dropdown-item" to="/mis-transacciones">Mis Transacciones</Link></li>
                    <li>
                      <Link className="dropdown-item d-flex justify-content-between align-items-center" to="/mensajes">
                        Mensajes
                        {noLeidos > 0 && (
                          <span className="badge bg-danger rounded-pill">{noLeidos > 9 ? '9+' : noLeidos}</span>
                        )}
                      </Link>
                    </li>
                    <li><Link className="dropdown-item" to="/mis-favoritos">Mis Favoritos</Link></li>
                    <li><Link className="dropdown-item" to="/editar-perfil">Editar Perfil</Link></li>
                    {(user.is_admin || user.username === 'admin') && (
                      <li><Link className="dropdown-item" to="/admin">Panel de Admin</Link></li>
                    )}
                    <li><hr className="dropdown-divider" /></li>
                    <li><button className="dropdown-item" onClick={handleLogout}>Cerrar Sesion</button></li>
                  </ul>
                </li>
              </>
            ) : (
              <>
                <li className="nav-item"><Link className="nav-link" to="/login">Ingresar</Link></li>
                <li className="nav-item"><Link className="btn btn-primary" to="/register">Crear cuenta</Link></li>
              </>
            )}
          </ul>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
